const initBlogResourceTracking = () => {
  if (document.documentElement.dataset.blogResourceTracking) return;
  document.documentElement.dataset.blogResourceTracking = 'true';

  const track = (event) => {
    if ((event.type === 'click' && event.button !== 0) || (event.type === 'auxclick' && event.button !== 1)) return;
    const link = event.target instanceof Element ? event.target.closest('a[data-blog-cta-track]') : null;
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if (!link?.dataset.blogCtaTrack || !token) return;

    const endpoint = new URL(link.dataset.blogCtaTrack, location.href);
    if (endpoint.origin !== location.origin) return;

    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'X-CSRF-TOKEN': token, 'Accept': 'application/json' },
    }).catch(() => {});
  };

  document.addEventListener('click', track);
  document.addEventListener('auxclick', track);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogResourceTracking, { once: true });
} else {
  initBlogResourceTracking();
}
